import axios from 'axios';
import {getCustomerUrl} from '~/utils/customer-util';
import {StatusCodes} from "http-status-codes";
import {ForceLoadedTermsRequest, Term} from "~/types/term-type.ts";

export default class TermService {
    static async updateTerms(cNum: string, serverBase: string, terms: Term[]) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/terms/update`);
        const resp = await axios.post(url, terms);
        return resp.status === StatusCodes.NO_CONTENT ? [] : resp.data;
    }

    static async forceImport(cNum: string, serverBase: string, data: ForceLoadedTermsRequest) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/terms/load/force`);
        const resp = await axios.post(url, data);
        return resp.status === StatusCodes.NO_CONTENT ? [] : resp.data;
    }

    static async autoImport(cNum: string, serverBase: string) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/terms/load/auto`);
        const resp = await axios.post(url, {cNum: cNum});
        return resp.status === StatusCodes.NO_CONTENT ? [] : resp.data;
    }

    static async loadTerms(cNum: string, serverBase: string) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/terms?fetchenabledonly=false`);
        const resp = await axios.get(url);
        return resp.status === StatusCodes.NO_CONTENT ? [] : resp.data;
    }
}
